import aboutImage from "../../assets/images/Rólam.jpg";
import SocialLinks from "../shared/SocialLinks";
import "./AboutSection.css";

const supportTopics = [
  "Hát-, nyak- és derékfájás",
  "Porckorongsérv",
  "Csípő-, térd-, bokaízületi panaszok",
  "Vállfájdalom, befagyott váll szindróma",
  "Teniszkönyök, golfkönyök",
  "Sérülés vagy műtét utáni rehabilitáció",
  "Gerincferdülés, hanyag tartás",
  "Lúdtalp, talpboltozat-süllyedés",
  "Izomfájdalmak",
];

const treatmentMethods = [
  "Alapos állapotfelmérés és anamnézis",
  "Személyre szabott kezelési terv ",
  "Modern, hatékony terápiás módszerek alkalmazása",
  "Folyamatos visszajelzés és kontroll",
  "Támogató, motiváló légkör",
];

function AboutSection() {
  return (
    <section className="section" id="rolam">
      <div className="about-layout">
        <div className="about-copy">
          <p className="eyebrow">Rólam</p>
          <h2>Mayer Nikolett</h2>
          <p className="about-copy__role">gyógytornász-fizioterapeuta</p>
          <p>
            Diplomámat 2022-ben szereztem a Szegedi Tudományegyetemen. Szakmai
            pályafutásomat az Országos Reumatológiai és Fizioterápiás Intézetben
            kezdtem, ahol két évig dolgoztam, és értékes tapasztalatokat
            szereztem a különböző mozgásszervi megbetegedések ellátásában. Ez
            idő alatt több továbbképzésen vettem részt, melyek során modern és
            hatékony terápiás módszereket sajátítottam el. Jelenleg
            magánegészségügyi rendelés keretében dolgozom, ahol a kezeléseket
            minden esetben az egyéni igényekhez igazítom.
          </p>
          <p>
            Célom, hogy pácienseim biztonságosan és a lehető leghatékonyabban
            térhessenek vissza mindennapi életükhöz, munkájukhoz,
            sporttevékenységükhöz. A mozgás mindig is fontos szerepet játszott
            az életemben. Hiszem, hogy a jól felépített terápia mellett az
            életmódra vonatkozó tanácsok is elengedhetetlenek a hosszú távon
            fenntartható, panaszmentes állapot eléréséhez.
          </p>

          <SocialLinks className="about-links" />
        </div>

        <div className="about-visual">
          <div className="portrait-card">
            <img
              src={aboutImage}
              alt="Mayer Nikolett portré"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>

      <div className="support-grid">
        <article className="info-card">
          <h3>Miben tudok segíteni?</h3>
          <ul className="bullet-list bullet-list--compact">
            {supportTopics.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>

        <article className="info-card">
          <h3>Amit nálam tapasztalhatsz</h3>
          <ul className="bullet-list bullet-list--compact">
            {treatmentMethods.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>
      </div>
    </section>
  );
}

export default AboutSection;
